import profile from './profile'
import label from './label'
import activity from './activity'
import event from './event'
import questionnaire from './questionnaire'
import symptom from './symptom'
import vital from './vital'
import lifestyle from './lifestyle'
import medication from './medication'
import article from './article'
import logic from './logic'

export default [
    profile,
	label,
    event,
    questionnaire,
    symptom,
    vital,
    lifestyle,
    // medication,
    article,
    activity
    // logic
]
